export default "__VITE_ASSET__f46c79b0__"